import { Platform } from 'root/src/shared/@types/platforms';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
// Resolve a creator's public profile URL from their preferred platform token. Shared by the
// RedesignNavbar user menu and the command palette so both link to the same destination. Uses the
// platform-specific profile URL (`/creators/<platform>/...`), which serves the redesign in place.
export const profileUrlFor = (platform, mnemonicId) => {
    if (!mnemonicId) {
        return undefined;
    }
    switch (platform) {
        case Platform.Twitch:
            return routeUrls.creatorsTwitch(mnemonicId);
        case Platform.YouTube:
            return routeUrls.creatorsYoutube(mnemonicId);
        case Platform.TikTok:
            return routeUrls.creatorsTiktok(mnemonicId);
        default:
            return undefined;
    }
};
